/* ==========================================================================
   Merry Glow theme - theme.js
   Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.merryGlow || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var lastAtc = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals}}', noDec)
      .replace('{{amount}}', withCommas);
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  }

  /* ---------------------------------------------------------------- */
  /* Announcement bar rotation                                         */
  /* ---------------------------------------------------------------- */
  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar.__ready) return;
      bar.__ready = true;
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4000;
      var index = 0;
      var paused = false;
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      bar.addEventListener('focusin', function () { paused = true; });
      bar.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------------------------------------------------------------- */
  /* Gallery                                                           */
  /* ---------------------------------------------------------------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', root);
    var dots = $$('[data-gallery-dot]', root);
    var current = $('[data-gallery-current]', root);
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    var thumbsWrap = $('[data-gallery-thumbs]', root);
    var index = 0;
    var ticking = false;

    function setActive(i) {
      index = i;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (current) current.textContent = String(i + 1);
      if (thumbsWrap && thumbs[i] && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        thumbsWrap.scrollTo({ left: thumbs[i].offsetLeft - thumbsWrap.clientWidth / 2 + thumbs[i].clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    function goTo(i) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: track.clientWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (i !== index) setActive(i);
      });
    }, { passive: true });

    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10)); }); });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    return {
      goToMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return; }
        }
      }
    };
  }

  /* ---------------------------------------------------------------- */
  /* Cart (drawer + AJAX)                                              */
  /* ---------------------------------------------------------------- */
  var Cart = {
    lastFocus: null,

    drawer: function () { return $('[data-cart-drawer]'); },

    open: function () {
      var drawer = this.drawer();
      if (!drawer) return false;
      this.lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('no-scroll');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-visible');
        var panel = $('.cart-drawer__panel', drawer);
        if (panel) panel.focus();
      });
      return true;
    },

    close: function () {
      var drawer = this.drawer();
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-visible');
      document.body.classList.remove('no-scroll');
      setTimeout(function () { drawer.hidden = true; }, reduceMotion ? 0 : 300);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    applyHtml: function (html) {
      var body = $('[data-cart-drawer-body]');
      if (!html || !body) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-drawer-body]', doc);
      if (fresh) body.innerHTML = fresh.innerHTML;
    },

    refresh: function () {
      var self = this;
      var bust = '&t=' + Date.now();
      var sectionReq = fetch(cfg.routes.cart + '?sections=cart-drawer' + bust, { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
      var cartReq = fetch(cfg.routes.cartJson + '?t=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
      return Promise.all([sectionReq, cartReq]).then(function (res) {
        self.applyHtml(res[0] && res[0]['cart-drawer']);
        self.updateCount(res[1].item_count);
        return res[1];
      });
    },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = String(count);
        el.hidden = !count;
      });
    },

    afterAdd: function () {
      if (cfg.cartType === 'drawer' && this.drawer()) {
        this.open();
      } else {
        window.location.href = cfg.routes.cart;
      }
    },

    change: function (line, quantity) {
      return fetch(cfg.routes.cartChange, {
        method: 'POST',
        headers: jsonHeaders(),
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); });
    }
  };

  /* ---------------------------------------------------------------- */
  /* Visit offer: while the visitor's timer runs, a discount code is on the */
  /* cart; when the timer ends (page kept open) the code is removed and     */
  /* prices go back to normal. Reloading the page starts a new window.      */
  /* ---------------------------------------------------------------- */
  var loadedAt = Date.now();
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var Offer = { cfg: cfg.offer || null, off: false, ready: false };

  function upper(s) { return String(s || '').toUpperCase(); }

  Offer.isTierCode = function (c) {
    return Offer.cfg.codes.some(function (t) { return upper(t) === upper(c); });
  };

  Offer.wanted = function (qty) {
    if (!Offer.cfg || Offer.off || qty < 1) return '';
    var c = Offer.cfg.codes;
    return qty >= 3 ? c[2] : (qty >= 2 ? c[1] : c[0]);
  };

  Offer.sync = function () {
    if (!Offer.cfg || inEditor) return Promise.resolve({ changed: false, ok: true });
    return fetch(cfg.routes.cartJson + '?t=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = 0;
        var ids = Offer.cfg.productIds && Offer.cfg.productIds.length ? Offer.cfg.productIds : [Offer.cfg.productId];
        (cart.items || []).forEach(function (i) { if (ids.indexOf(i.product_id) > -1) qty += i.quantity; });
        var want = Offer.wanted(qty);
        var codes = cart.discount_codes || [];
        var have = codes.map(function (c) { return c.code; });
        var keep = have.filter(function (c) { return !Offer.isTierCode(c); });
        var tiers = have.filter(Offer.isTierCode);
        var same = want ? (tiers.length === 1 && upper(tiers[0]) === upper(want)) : tiers.length === 0;
        if (same) {
          var fine = !want || codes.some(function (c) { return upper(c.code) === upper(want) && c.applicable; });
          if (!fine) Offer.setOff();
          return { changed: false, ok: fine };
        }
        var list = keep.concat(want ? [want] : []);
        return fetch(cfg.routes.cartUpdate, {
          method: 'POST',
          headers: jsonHeaders(),
          body: JSON.stringify({ discount: list.join(','), sections: 'cart-drawer', sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); }).then(function (res) {
          var ok = !want || (res.discount_codes || []).some(function (c) { return upper(c.code) === upper(want) && c.applicable; });
          if (!ok) Offer.setOff();
          return { changed: true, ok: ok, html: res.sections && res.sections['cart-drawer'] };
        });
      })
      .catch(function () { return { changed: false, ok: false }; });
  };

  /* normal prices everywhere (the code is no longer on the cart or could not be applied) */
  Offer.setOff = function () {
    if (Offer.off) return;
    Offer.off = true;
    document.documentElement.classList.add('offer-off');
    $$('[data-offer-timer]').forEach(function (el) { el.hidden = true; });
    $$('.announcement__item').forEach(function (el) { if (/\d+\s*%/.test(el.textContent)) el.hidden = true; });
    $$('[data-price-off]').forEach(function (el) { el.textContent = el.getAttribute('data-price-off'); });
    $$('[data-label-off]').forEach(function (el) { el.textContent = el.getAttribute('data-label-off'); });
    document.dispatchEvent(new CustomEvent('offer:off'));
  };

  /* the visitor's window is over */
  Offer.expire = function () {
    if (!Offer.cfg) { $$('[data-offer-timer]').forEach(function (el) { el.hidden = true; }); return; }
    if (Offer.off) return;
    Offer.setOff();
    Offer.sync().then(function (r) {
      if (document.body.className.indexOf('template-cart') !== -1) { window.location.reload(); return; }
      if (r && r.html) Cart.applyHtml(r.html); else Cart.refresh();
    });
  };

  function initOffer() {
    if (!Offer.cfg || Offer.ready || inEditor) return;
    Offer.ready = true;
    Offer.sync().then(function (r) {
      if (!r || !r.changed) return;
      if (document.body.className.indexOf('template-cart') !== -1) {
        var last = 0;
        try { last = parseInt(window.sessionStorage.getItem('mgCartFix'), 10) || 0; window.sessionStorage.setItem('mgCartFix', String(Date.now())); } catch (e) {}
        if (Date.now() - last > 20000) window.location.reload();
      } else if (r.html) {
        Cart.applyHtml(r.html);
      }
    });
  }

  function initCartGlobal() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && cfg.cartType === 'drawer' && Cart.drawer() && document.body.className.indexOf('template-cart') === -1) {
        e.preventDefault();
        Cart.open();
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        Cart.close();
        return;
      }
      var changer = e.target.closest('[data-cart-change]');
      if (changer) {
        var line = parseInt(changer.getAttribute('data-line'), 10);
        var qty = Math.max(0, parseInt(changer.getAttribute('data-quantity'), 10) || 0);
        var item = changer.closest('[data-cart-item]');
        if (item) item.classList.add('is-updating');
        Cart.change(line, qty).then(function (data) {
          if (changer.closest('[data-cart-page]')) {
            window.location.reload();
            return;
          }
          return Offer.sync().then(function (r) {
            var html = (r && r.html) || (data && data.sections && data.sections['cart-drawer']);
            if (html) {
              Cart.applyHtml(html);
              Cart.updateCount(data && data.item_count);
            } else {
              return Cart.refresh();
            }
          });
        }).catch(function () {
          if (item) item.classList.remove('is-updating');
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      var drawer = Cart.drawer();
      if (!drawer || drawer.hidden) return;
      if (e.key === 'Escape') { Cart.close(); return; }
      if (e.key === 'Tab') {
        var focusable = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', drawer).filter(function (el) { return el.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------------------------------------------------------------- */
  /* Delivery timeline (calculated dates, skips weekends)              */
  /* ---------------------------------------------------------------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function formatDate(d) {
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    catch (err) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  }

  function formatRange(a, b) {
    var fa = formatDate(a);
    var fb = formatDate(b);
    return fa === fb ? fa : fa + ' - ' + fb;
  }

  function initDelivery(root) {
    $$('[data-delivery]', root).forEach(function (el) {
      var today = new Date();
      var shipMin = parseInt(el.getAttribute('data-ship-min'), 10) || 0;
      var shipMax = parseInt(el.getAttribute('data-ship-max'), 10) || shipMin;
      var delMin = parseInt(el.getAttribute('data-deliver-min'), 10) || 0;
      var delMax = parseInt(el.getAttribute('data-deliver-max'), 10) || delMin;
      var map = {
        ordered: formatDate(today),
        shipped: formatRange(addBusinessDays(today, shipMin), addBusinessDays(today, shipMax)),
        delivered: formatRange(addBusinessDays(today, delMin), addBusinessDays(today, delMax))
      };
      $$('[data-delivery-date]', el).forEach(function (node) {
        var key = node.getAttribute('data-delivery-date');
        if (map[key]) node.textContent = map[key];
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Product section                                                   */
  /* ---------------------------------------------------------------- */
  function initProduct(section) {
    if (section.__ready) return;
    section.__ready = true;

    var gallery = initGallery(section);
    var variantsEl = $('[data-variants]', section);
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (err) { variants = []; }

    var form = $('[data-product-form]', section);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var qtyInput = form ? $('[data-qty-input]', form) : null;
    var addBtn = form ? $('[data-add-to-cart]', form) : null;
    var addLabel = form ? $('[data-add-label]', form) : null;
    var errorEl = form ? $('[data-form-error]', form) : null;
    var productUrl = section.getAttribute('data-product-url');

    var currentVariant = null;
    for (var i = 0; i < variants.length; i++) {
      if (idInput && String(variants[i].id) === String(idInput.value)) currentVariant = variants[i];
    }
    var selected = currentVariant ? currentVariant.options.slice() : [];

    /* quantity helpers */
    var qtyDisplay = $('[data-qty-display]', section);
    var qbInputs = $$('[data-qb-input]', section);

    function setQty(n) {
      n = Math.max(1, parseInt(n, 10) || 1);
      if (qtyInput) qtyInput.value = String(n);
      if (qtyDisplay) qtyDisplay.value = String(n);
    }

    function syncQb() {
      qbInputs.forEach(function (input) {
        var card = input.closest('.qb__card');
        if (card) card.classList.toggle('is-selected', input.checked);
      });
    }

    var addonInputs = $$('[data-addon]', section);

    /* extras only count for the card that is currently selected */
    function checkedAddons() {
      var list = [];
      var picked = null;
      qbInputs.forEach(function (input) { if (input.checked) picked = input; });
      var card = picked ? picked.closest('.qb__card') : null;
      if (!card) return list;
      $$('[data-addon]', card).forEach(function (a) {
        if (a.checked) list.push({ id: parseInt(a.getAttribute('data-variant'), 10), cents: parseInt(a.getAttribute('data-cents'), 10) || 0 });
      });
      return list;
    }

    function clearOtherAddons(current) {
      var keep = current.closest('.qb__card');
      addonInputs.forEach(function (a) { if (a.closest('.qb__card') !== keep) a.checked = false; });
    }

    function updateAtc() {
      var totalEl = $('[data-atc-total]', section);
      var fullEl = $('[data-atc-full]', section);
      var wrap = $('[data-atc-price]', section);
      if (!totalEl || !currentVariant) return;
      var total = 0;
      var full = 0;
      var idx = -1;
      qbInputs.forEach(function (input, n) { if (input.checked) idx = n; });
      var tier = idx > -1 && currentVariant.tiers ? currentVariant.tiers[idx] : null;
      if (tier) { total = tier.totalCents; full = tier.fullCents; }
      else {
        var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
        total = currentVariant.priceCents * q;
        full = total;
      }
      checkedAddons().forEach(function (a) { total += a.cents; full += a.cents; });
      totalEl.textContent = formatMoney(total);
      if (fullEl) { fullEl.textContent = formatMoney(full); fullEl.hidden = !(full > total); }
      if (wrap) wrap.hidden = !currentVariant.available;
      lastAtc = { total: total, full: full, available: currentVariant.available };
      document.dispatchEvent(new CustomEvent('atc:update', { detail: lastAtc }));
    }

    addonInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var card = input.closest('.qb__card');
        var radio = card ? $('[data-qb-input]', card) : null;
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        updateAtc();
      });
    });

    qbInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) { setQty(input.value); clearOtherAddons(input); }
        syncQb();
        updateAtc();
      });
    });
    syncQb();
    updateAtc();

    function clearQbSelection() {
      var match = false;
      qbInputs.forEach(function (input) {
        var same = qtyInput && input.value === qtyInput.value;
        input.checked = same && !match;
        if (same) match = true;
      });
      syncQb();
    }

    var minus = $('[data-qty-minus]', section);
    var plus = $('[data-qty-plus]', section);
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); clearQbSelection(); updateAtc(); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); clearQbSelection(); updateAtc(); });
    if (qtyDisplay) qtyDisplay.addEventListener('change', function () { setQty(qtyDisplay.value); clearQbSelection(); updateAtc(); });

    /* variant selection */
    function findVariant() {
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var o = 0; o < selected.length; o++) {
          if (variants[v].options[o] !== selected[o]) { ok = false; break; }
        }
        if (ok) return variants[v];
      }
      return null;
    }

    function setText(sel, text) {
      $$(sel, section).forEach(function (el) { el.textContent = text; });
    }

    function applyVariant(variant) {
      currentVariant = variant;
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = cfg.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;

      setText('[data-price-current]', variant.price);
      $$('[data-price-compare]', section).forEach(function (el) { el.textContent = variant.compare; el.hidden = !variant.onSale; });
      $$('[data-price-badge]', section).forEach(function (el) { el.textContent = variant.saveLabel; el.hidden = !variant.onSale; });
      $$('[data-price]', section).forEach(function (el) { el.classList.toggle('price--on-sale', !!variant.onSale); });

      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? cfg.strings.addToCart : cfg.strings.soldOut;

      qbInputs.forEach(function (input, n) {
        var tier = variant.tiers && variant.tiers[n];
        var card = input.closest('.qb__card');
        if (!tier || !card) return;
        var total = $('[data-qb-total]', card);
        var full = $('[data-qb-full]', card);
        var each = $('[data-qb-each]', card);
        var save = $('[data-qb-save]', card);
        var off = $('[data-qb-off]', card);
        if (off) { off.textContent = tier.pctLabel; off.hidden = !(tier.pct > 0); }
        if (save) { save.textContent = tier.saveLabel; save.hidden = !tier.showFull; }
        if (total) total.textContent = tier.total;
        if (full) { full.textContent = tier.full; full.hidden = !tier.showFull; }
        if (each) each.textContent = tier.each;
      });

      if (gallery && variant.mediaId) gallery.goToMedia(variant.mediaId);

      if (productUrl && window.history && window.history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
        window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
      }

      updateAtc();
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    /* the visitor's offer window is over: show normal prices on the cards and the buttons */
    function applyOfferOff() {
      variants.forEach(function (v) {
        (v.tiers || []).forEach(function (t) {
          t.totalCents = t.fullCents;
          t.total = t.full;
          t.showFull = false;
          t.pct = 0;
          t.each = formatMoney(Math.round(t.fullCents / (t.qty || 1)));
        });
      });
      if (currentVariant) applyVariant(currentVariant);
    }
    document.addEventListener('offer:off', applyOfferOff);
    if (Offer.off) applyOfferOff();

    $$('[data-option-index]', section).forEach(function (fieldset) {
      var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);
      var label = $('[data-option-value]', fieldset);
      $$('input[type="radio"]', fieldset).forEach(function (radio) {
        radio.addEventListener('change', function () {
          selected[optionIndex] = radio.value;
          if (label) label.textContent = radio.value;
          applyVariant(findVariant());
        });
      });
    });

    /* add to cart */
    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || cfg.strings.error;
      errorEl.hidden = false;
    }

    function submitCart(goCheckout, trigger) {
      if (!addBtn || addBtn.disabled || !idInput) return;
      if (errorEl) errorEl.hidden = true;
      var busy = [addBtn];
      if (trigger && trigger !== addBtn) busy.push(trigger);
      busy.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });

      var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }];
      checkedAddons().forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });
      var payload = { items: items, sections: 'cart-drawer', sections_url: window.location.pathname };
      var leaving = false;
      fetch(cfg.routes.cartAdd, { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(payload) })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            throw new Error(result.data.description || result.data.message || cfg.strings.error);
          }
          return Offer.sync().then(function (offerRes) {
            if (goCheckout) {
              leaving = true;
              window.location.href = cfg.routes.checkout || '/checkout';
              return;
            }
            return Cart.refresh().then(function () {
              var html = (offerRes && offerRes.html) || (result.data.sections && result.data.sections['cart-drawer']);
              if (html) Cart.applyHtml(html);
            }).then(function () { Cart.afterAdd(); });
          });
        })
        .catch(function (err) {
          showError(err && err.message);
          if (goCheckout && errorEl && errorEl.scrollIntoView) errorEl.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        })
        .then(function () {
          if (leaving) return;
          busy.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
        });
    }

    section.__buyNow = function (trigger) { submitCart(true, trigger); };

    if (form) {
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.name && submitter.name !== 'add') return;
        e.preventDefault();
        submitCart(false, addBtn);
      });
    }
  }

  /* ---------------------------------------------------------------- */
  /* Sticky add to cart                                                */
  /* ---------------------------------------------------------------- */
  function initSticky() {
    var bar = $('[data-sticky-atc]');
    var section = $('[data-product-section]');
    var mainBtn = section && $('[data-add-to-cart]', section);
    if (!bar || !mainBtn || bar.__ready) return;
    bar.__ready = true;
    var stickyBtn = $('[data-sticky-atc-button]', bar);

    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-atc', show);
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    }

    /* visible whenever the main button is off screen (mobile: from the start; desktop: after scrolling past it) */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(mainBtn);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        if (section.__buyNow) section.__buyNow(stickyBtn);
      });
    }

    var price = $('[data-sticky-price]', bar);
    var compare = $('[data-sticky-compare]', bar);
    var label = $('[data-sticky-label]', bar);

    function paint(d) {
      if (price) price.textContent = formatMoney(d.total);
      if (compare) { compare.textContent = formatMoney(d.full); compare.hidden = !(d.full > d.total); }
      if (stickyBtn) stickyBtn.disabled = !d.available;
      if (label && stickyBtn) label.textContent = d.available ? (stickyBtn.getAttribute('data-label') || 'Buy Now') : cfg.strings.soldOut;
    }
    document.addEventListener('atc:update', function (e) { paint(e.detail); });
    if (lastAtc) paint(lastAtc);
  }

  /* One-click buy (final call to action): adds the variant and goes to checkout */
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-scroll-qb]');
    if (jump) {
      e.preventDefault();
      var target = $('[data-qb]') || $('[data-product-section]');
      if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      return;
    }
    var btn = e.target.closest('[data-quick-buy]');
    if (!btn || btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    if (!id) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch(cfg.routes.cartAdd, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ items: [{ id: id, quantity: parseInt(btn.getAttribute('data-qty'), 10) || 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error(cfg.strings.error); return Offer.sync(); })
      .then(function () { window.location.href = cfg.routes.checkout || '/checkout'; })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        window.location.href = cfg.routes.cart;
      });
  });

  /* ---------------------------------------------------------------- */
  /* Holiday offer countdown (counts down to a fixed, real end date)   */
  /* ---------------------------------------------------------------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* End of a countdown. Personal timers (default): the visitor's window starts when the page loads
     (nothing is stored, a reload starts a new one). Shared timers count down to the campaign end. */
  function timerEnd(el) {
    if (el.hasAttribute('data-personal')) {
      var end = loadedAt + (parseFloat(el.getAttribute('data-window')) || 24) * 3600000;
      var camp = parseInt(el.getAttribute('data-campaign-end'), 10) * 1000;
      return camp && camp < end ? camp : end;
    }
    return parseInt(el.getAttribute('data-end'), 10) * 1000;
  }

  function initOfferTimer(root) {
    $$('[data-offer-timer]', root).forEach(function (el) {
      if (el.__ready) return;
      el.__ready = true;
      if (Offer.off) { el.hidden = true; return; }
      var end = timerEnd(el);
      var out = $('[data-offer-timer-value]', el);
      var uh = $('[data-t-h]', el);
      var um = $('[data-t-m]', el);
      var us = $('[data-t-s]', el);
      if (!end || !(out || uh)) return;
      var started = end - Date.now() > 0;
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          el.hidden = true;
          if (Offer.cfg || el.hasAttribute('data-personal')) {
            Offer.expire();
          } else if (started && !inEditor) {
            /* the offer is really over: reload so prices and discounts match checkout */
            window.location.reload();
          }
          return false;
        }
        var h = Math.floor(left / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;
        if (uh) { uh.textContent = pad(h); um.textContent = pad(m); us.textContent = pad(s); }
        if (out) {
          var days = Math.floor(left / 86400);
          out.textContent = (days > 0 ? days + 'd ' : '') + pad(Math.floor((left % 86400) / 3600)) + ':' + pad(m) + ':' + pad(s);
        }
        return true;
      }
      if (tick()) {
        el.classList.add('is-ready');
        var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
      }
    });
  }

  /* ---------------------------------------------------------------- */
  /* "See it in action": a tap plays the video inside its tile (no pop-up) */
  /* ---------------------------------------------------------------- */
  function stopVideo(item) {
    var player = item && $('.sia__player', item);
    if (player) player.remove();
    if (item) item.classList.remove('is-playing');
  }

  document.addEventListener('click', function (e) {
    var stop = e.target.closest('[data-video-stop]');
    if (stop) { stopVideo(stop.closest('.sia__item')); return; }
    var open = e.target.closest('[data-video-open]');
    if (!open) return;
    var item = open.closest('.sia__item');
    var tpl = item && $('[data-video-template]', item);
    if (!item || !tpl || item.classList.contains('is-playing')) return;
    $$('.sia__item.is-playing').forEach(stopVideo);
    var player = document.createElement('div');
    player.className = 'sia__player';
    player.appendChild(tpl.content.cloneNode(true));
    item.appendChild(player);
    item.classList.add('is-playing');
    var video = $('video', player);
    if (video) {
      video.setAttribute('playsinline', '');
      if (video.hasAttribute('muted')) video.muted = true;
      if (!video.controls) video.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (item.scrollIntoView) item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
  });

  /* ---------------------------------------------------------------- */
  /* Order tracker (opens 17TRACK with the number pre-filled)          */
  /* ---------------------------------------------------------------- */
  function initTracker(root) {
    $$('[data-tracker]', root).forEach(function (form) {
      if (form.__ready) return;
      form.__ready = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = $('input[type="text"]', form);
        var number = input && input.value.replace(/\s+/g, '');
        if (!number) { if (input) input.focus(); return; }
        window.open('https://t.17track.net/en#nums=' + encodeURIComponent(number), '_blank', 'noopener');
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Back to top                                                       */
  /* ---------------------------------------------------------------- */
  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn || btn.__ready) return;
    btn.__ready = true;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        btn.hidden = window.scrollY < 700;
      });
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Testimonials carousel (1 card on phones, 3 on computers, drag / swipe) */
  /* ---------------------------------------------------------------- */
  function initTestimonials(root) {
    $$('[data-tcar]', root).forEach(function (car) {
      if (car.__ready) return;
      car.__ready = true;
      var track = $('[data-tcar-track]', car);
      var cards = track ? $$('.testimonial', track) : [];
      if (!track || !cards.length) return;
      var prev = $('[data-tcar-prev]', car);
      var next = $('[data-tcar-next]', car);
      var dots = $$('[data-tcar-dot]', car);

      function step() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      }
      function index() { return Math.round(track.scrollLeft / step()); }
      function go(i) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({ left: i * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function update() {
        var i = index();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        car.classList.toggle('is-static', track.scrollWidth - track.clientWidth <= 2);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }

      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });

      /* mouse drag (touch screens already swipe natively) */
      var down = false;
      var moved = false;
      var startX = 0;
      var startLeft = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        if (moved) go(index());
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      update();
    });
  }

  /* ---------------------------------------------------------------- */
  /* Reveal sections while scrolling (CSS only hides them when .js-reveal is set) */
  /* ---------------------------------------------------------------- */
  function initReveal() {
    var docEl = document.documentElement;
    if (!docEl.classList.contains('js-reveal') || window.__mgReveal) return;
    window.__mgReveal = true;

    var items = [];
    function add(el, delay) {
      if (!el || el.__reveal) return;
      el.__reveal = true;
      el.setAttribute('data-reveal', '');
      if (delay) el.style.setProperty('--reveal-delay', delay + 'ms');
      items.push(el);
    }

    $$('#MainContent .shopify-section').forEach(function (sec) {
      if ($('[data-product-section]', sec) || $('.wave-divider', sec) || $('[data-sticky-atc]', sec)) return;
      var inner = $('.container', sec);
      if (!inner) return;
      Array.prototype.forEach.call(inner.children, function (child) {
        var kids = child.children;
        var grid = kids.length > 1 && /^(UL|OL)$/.test(child.tagName) || /(benefits|cards|ugc|steps|grid|list)/.test(child.className);
        if (grid && kids.length > 1) {
          Array.prototype.forEach.call(kids, function (kid, i) { add(kid, Math.min(i, 5) * 90); });
        } else {
          add(child);
        }
      });
    });

    if (!items.length) { docEl.classList.remove('js-reveal'); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          var el = entry.target;
          el.classList.add('is-in');
          io.unobserve(el);
          /* once shown, drop the reveal hooks so normal hover effects work again */
          setTimeout(function () {
            el.removeAttribute('data-reveal');
            el.classList.remove('is-in');
            el.style.removeProperty('--reveal-delay');
          }, 1500);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------- */
  /* Boot                                                              */
  /* ---------------------------------------------------------------- */
  function init(root) {
    root = root || document;
    initAnnouncement(root);
    initDelivery(root);
    initOfferTimer(root);
    initOffer();
    initTracker(root);
    $$('[data-product-section]', root).forEach(initProduct);
    initSticky();
    initBackToTop();
    initTestimonials(root);
    initReveal();
  }

  initCartGlobal();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
